const addDevToolsClickListener = (ref, enableDevTools) => {
  const listener = (e) => {
    if (e.metaKey && e.shiftKey && e.altKey && e.detail === 2) {
      enableDevTools();
    }
  };
  ref?.addEventListener("click", listener, { capture: true });
  return () => ref?.removeEventListener("click", listener);
};
export {
  addDevToolsClickListener
};
//# sourceMappingURL=add-dev-tools-click-listener.js.map
